import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Icon, Table, TableBody, TableRow, TableCell, Tooltip } from '@material-ui/core'
import { withI18n, WithI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { submit, isInvalid } from 'redux-form'
import Btn from 'src/shared/Btn/Btn'
import PcDialog from 'src/shared/Dialog/PcDialog'
import BtnActions from 'src/shared/Btn/BtnActions'
import InformationContractualForm from 'src/page/Consumer/Enterprise/forms/InformationContractualForm'
import { updateEnterprise } from 'src/core/redux/action/enterpriseInfosAction'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast } from 'src/shared/Toast/Toast'
import Alert from 'src/shared/Alert/Alert'
import { Address } from 'src/shared/Address/Address'
import { fetchAccountInfos } from 'src/core/redux/action/accountInfosAction'
import { mapValuesContractual } from 'src/shared/utils/helpers'

const styles = (t: Theme) => createStyles({
  expansionPnl: {
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    },
  },
  title: {
    textTransform: 'uppercase'
  },
  typo: {
    padding: '4px 0'
  },
  info: {
    paddingLeft: '5px'
  },
  chip: {
    margin: `0 ${t.spacing.unit / 2}px`
  },
  xsScroll: {
    [t.breakpoints.down('sm')]: {
      overflow: 'auto'
    },
  },
  titleCell: {
    width: '400px',
    minWidth: '400px',
    maxWidth: '400px',
    [t.breakpoints.down('sm')]: {
      width: '300px',
      minWidth: '300px',
      maxWidth: '300px',
    },
  },
  invisibleForm: {
    height: 0,
    width: 0,
    overflow: 'hidden'
  },
  table: {
    '& tbody tr td': {
      whiteSpace: 'normal'
    }
  }
});


interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  WithGlobalProgress,
  WithToast,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

interface IStates {
  modalInfoContractual: boolean;
  popupMode: string;
}

class EnterpriseContractual extends React.Component<IProps, IStates> {
  state = {
    modalInfoContractual: false,
    popupMode: "EDIT"
  }

  render() {
    const { t, classes, enterprise } = this.props;
    return (
      <>
        <ExpansionPanel defaultExpanded={true} className={classes.expansionPnl}>
          <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
            <Typography variant="subtitle2" className={classes.title}>{t.EnterpriseDetail_info_contractual_title_first}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.xsScroll}>
            <div style={{ width: '100%' }}>
              {(enterprise.is_mandataire === true && enterprise.can_edit_contractual_data === true) &&
                <Alert type="unlock" className="gutterBottom">
                  {t.EnterpriseDetail_info_contractual_editable_description}
                </Alert>
              }
              <Alert type="info"><b>{t.notification} : </b> {t.EnterpriseDetail_info_contractual_notifications}</Alert>
              <br />
              {this.tableInfos()}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingTop: '1rem', width: '100%' }}>
                {enterprise.is_mandataire === true &&
                  <>
                    {enterprise.can_edit_contractual_data === false &&
                      <Tooltip title={t.EnterpriseDetail_info_contractual_uneditable_description} placement="bottom-start">
                        <span>
                          <Btn
                            color='primary'
                            onClick={this.toggleModalInfoContractual}
                            icon='lock'
                            disabled={enterprise.can_edit_contractual_data === false}
                          >
                            {t.edit}
                          </Btn>
                        </span>
                      </Tooltip>
                    }
                    {enterprise.can_edit_contractual_data === true &&
                      <Btn
                        color='primary'
                        onClick={this.toggleModalInfoContractual}
                        icon='lock_open'
                      >
                        {t.edit}
                      </Btn>
                    }
                  </>
                }
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <PcDialog
          open={this.state.modalInfoContractual}
          title={t.EnterpriseDetail_info_contractual_title_edit}
          maxWidth="md"
          fullWidth={true}
          actions={this.modalActions()}
        >
          <div className={this.state.popupMode === "CONFIRM" ? classes.invisibleForm : ''}>
            <Alert type="warning">{t.EnterpriseDetail_info_contractual_modal_confirm}</Alert>
            {enterprise.person_to_notify_email &&
              <InformationContractualForm
                onSubmit={this.handleSubmitForm}
                initialValues={{
                  person_to_notify_first_name: enterprise.person_to_notify_first_name,
                  person_to_notify_last_name: enterprise.person_to_notify_last_name,
                  person_to_notify_email: enterprise.person_to_notify_email,
                  person_to_notify_address: enterprise.person_to_notify_address,
                  emir_status: enterprise.emir_status,
                  lei: enterprise.lei,
                  rcs_city_legal_representative: enterprise.rcs_city_legal_representative,
                  siren_legal_representative: enterprise.siren_legal_representative,
                }}
              />
            }
            {!enterprise.person_to_notify_email &&
              <InformationContractualForm
                onSubmit={this.handleSubmitForm}
              />
            }
          </div>
          {this.state.popupMode === "CONFIRM" && t.EnterpriseDetail_info_contractual_modal_confirm}
        </PcDialog>
      </>
    )
  }

  @autobind
  private tableInfos() {
    const { t, enterprise, classes } = this.props;
    const { person_to_notify_last_name, person_to_notify_first_name, person_to_notify_email = '-', person_to_notify_address, emir_status = '-' } = enterprise

    const infos = [
      { label: t.EnterpriseDetail_info_contractual_person_to_notify, value: (person_to_notify_last_name && person_to_notify_first_name) ? person_to_notify_last_name + " " + person_to_notify_first_name : '-' },
      { label: t.EnterpriseDetail_info_contractual_email_person_to_notify, value: person_to_notify_email },
      { label: t.EnterpriseDetail_info_contractual_address_person_to_notify, value: person_to_notify_address.city ? <Address {...person_to_notify_address} /> : '-' },
      { label: t.EnterpriseDetail_info_contractual_status_emir, value: emir_status },
    ]
    return (
      <Table className={classes.table}>
        <TableBody>
          {infos.map(i => (
            <TableRow>
              <TableCell className={classes.titleCell}>
                <Typography variant="body2" className={classes.typo}>{i.label}</Typography>
              </TableCell>
              <TableCell>{i.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  @autobind
  private modalActions() {
    const { t } = this.props
    switch (this.state.popupMode) {
      case "EDIT":
        return (
          <BtnActions
            cancelHandler={this.toggleModalInfoContractual}
            confirmHandler={() => this.changeTypeModal("CONFIRM")}
            disableNext={this.props.isInfoContractualFormValid}
            confirmLabel={t.save}
          />
        )
      case "CONFIRM":
        return (
          <BtnActions
            cancelHandler={() => {
              this.toggleModalInfoContractual()
              this.setState({ popupMode: "EDIT" })
            }}
            confirmHandler={this.submitFormRemotely}
            confirmLabel={t.confirm}
          />
        )
      default:
        return ""
    }
  }

  @autobind
  private changeTypeModal(mode: string) {
    this.setState({ popupMode: mode })
  }

  @autobind
  private toggleModalInfoContractual() {
    this.setState({ modalInfoContractual: !this.state.modalInfoContractual })
  }

  @autobind
  private submitFormRemotely() {
    this.props.submitForm(submit("informationContractualForm"));
    this.changeTypeModal("EDIT")
    this.toggleModalInfoContractual();
  };

  @autobind
  private handleSubmitForm(values) {
    const { updateEnterpriseInfo, promisesWithProgress, toastError, enterprise, toastSuccess, t } = this.props
    promisesWithProgress(
      updateEnterpriseInfo(enterprise.id, mapValuesContractual(values)).then(res => {
        toastSuccess(t.EnterpriseDetail_info_contractual_edit_sucess)
      }).catch(err => toastError(err.msg))
    )
  }
}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected,
  isInfoContractualFormValid: isInvalid("informationContractualForm")(state),
});

const dispatch2props = dispatch => ({
  submitForm: (handerSubmit) => dispatch(handerSubmit),
  fetchInfos: () => dispatch(fetchAccountInfos()),
  updateEnterpriseInfo: (id: string, data: any) => dispatch(updateEnterprise(id, data))
});

export default compose(
  withI18n,
  withGlobalProgress,
  withToast,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(EnterpriseContractual)



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/cards/EnterpriseContractual.tsx